import { Container } from 'react-bootstrap';
import styled from 'styled-components';

import { Caption } from 'components/ui/Caption';
import { DiamondSeparator } from 'components/ui/Separators';

const AboutUsBodySection = styled.section`
    padding-top: 80px;
    padding-bottom: 60px;

    background-color: var(--background-white);
`;

function AboutUsSection(): JSX.Element {
    return (
        <AboutUsBodySection id="about">
            <Container>
                <Caption>
                    <h2>
                        ¿Quiénes <strong>Somos</strong>?
                    </h2>
                    <DiamondSeparator />
                    <p>
                        Somos distribuidores de la editorial Norma, ediciones
                        Lexicom, editorial San Marcos, editorial María Trinidad
                        (solo Puno y Juliaca), editorial Edinun y editorial
                        Hamilton House.
                    </p>
                </Caption>
            </Container>
        </AboutUsBodySection>
    );
}

export default AboutUsSection;
